import { UserService } from "@nuskin/ns-account";
import { RunConfigService } from "@nuskin/ns-util";
import axios from "axios";

function getApiBaseUrl() {
  /** @type {"dev"|"test"|"stage"|"prod"|"unknown"} */
  const env = RunConfigService.getEnvironmentCode();

  switch (env) {
    case "prod":
      return "https://product-recommendations.api.nuskin.com";
    case "test":
      return "https://product-recommendations.api.test.nuskin.com";
    case "unknown":
    case "dev":
    default:
      return "https://product-recommendations.api.dev.nuskin.com";
  }
}

/**
 *
 * @param {number} [limit] Maximum number of recommended products to return
 * @return {Promise<string[]>} List of SKU IDs of recommended products
 */
export async function getPersonalizedRecommendations(limit) {
  // Get user ID
  const user = UserService.getUser();
  if (!user) return [];
  const userId = user.id;

  // Get okta access token
  const tokensString = sessionStorage.getItem("oktaTokens");
  if (!tokensString) return [];
  const { accessToken } = JSON.parse(tokensString);

  const baseUrl = getApiBaseUrl();
  const url = new URL(`/v1/personalized-for/${userId}`, baseUrl).toString();

  const { data } = await axios.get(url, {
    headers: { Authorization: `Bearer ${accessToken}` },
    params: { limit }
  });

  return data.recommendedSkus || [];
}

/**
 *
 * @param {string} sku Product SKU ID
 * @param {number} [limit] Maximum number of recommended products to return
 * @return {Promise<string[]>} List of SKU IDs of recommended products
 */
export async function getRelatedProducts(sku, limit) {
  // // If no SKU ID is given, don't attempt to retrieve related products
  if (!sku) return [];

  const baseUrl = getApiBaseUrl();
  const url = new URL(`/v1/related-to/${sku}`, baseUrl).toString();

  const { data } = await axios.get(url, {
    params: { limit }
  });

  return data.recommendedSkus || [];
}
